import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Future: load essential assets (logo, loading bar sprite)
  }

  create(): void {
    // Boot complete, proceed to preload
    this.scene.start('PreloadScene');
  }
}
